"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChainRegistryChainUtil = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _utils = require("@chain-registry/utils");
var ChainRegistryChainUtil = /*#__PURE__*/function () {
  function ChainRegistryChainUtil(options) {
    (0, _classCallCheck2["default"])(this, ChainRegistryChainUtil);
    (0, _defineProperty2["default"])(this, "chainName", void 0);
    (0, _defineProperty2["default"])(this, "chainInfo", void 0);
    (0, _defineProperty2["default"])(this, "_assets", []);
    this.chainName = options.chainName;
    this.chainInfo = options.chainInfo;
    this._assets = [{
      assets: [].concat((0, _toConsumableArray2["default"])(this.chainInfo.nativeAssetList.assets), (0, _toConsumableArray2["default"])(this.chainInfo.assetLists.flatMap(function (_ref) {
        var assets = _ref.assets;
        return assets;
      }))),
      chain_name: this.chainName
    }];
  }
  (0, _createClass2["default"])(ChainRegistryChainUtil, [{
    key: "getAssetByDenom",
    value: function getAssetByDenom(denom) {
      return (0, _utils.getAssetByDenom)(this._assets, denom, this.chainName);
    }
  }, {
    key: "getDenomByCoinGeckoId",
    value: function getDenomByCoinGeckoId(coinGeckoId) {
      return (0, _utils.getDenomByCoinGeckoId)(this._assets, coinGeckoId, this.chainName);
    }
  }, {
    key: "getCoinGeckoIdByDenom",
    value: function getCoinGeckoIdByDenom(coinGeckoId) {
      return (0, _utils.getCoinGeckoIdByDenom)(this._assets, coinGeckoId, {
        chainName: this.chainName
      });
    }
  }, {
    key: "getSymbolByChainDenom",
    value: function getSymbolByChainDenom(denom) {
      return (0, _utils.getSymbolByChainDenom)(this._assets, denom, this.chainName);
    }
  }, {
    key: "getChainDenomBySymbol",
    value: function getChainDenomBySymbol(token) {
      return (0, _utils.getChainDenomBySymbol)(this._assets, token, this.chainName);
    }
  }, {
    key: "getExponentByDenom",
    value: function getExponentByDenom(denom) {
      return (0, _utils.getExponentByDenom)(this._assets, denom, this.chainName);
    }
  }, {
    key: "convertCoinGeckoPricesToDenomPriceMap",
    value: function convertCoinGeckoPricesToDenomPriceMap(prices) {
      return (0, _utils.convertCoinGeckoPricesToDenomPriceMap)(this._assets, prices);
    }
  }, {
    key: "noDecimals",
    value: function noDecimals(num) {
      return (0, _utils.noDecimals)(num);
    }
  }, {
    key: "convertBaseUnitsToDollarValue",
    value: function convertBaseUnitsToDollarValue(prices, symbol, amount) {
      return (0, _utils.convertBaseUnitsToDollarValue)(this._assets, prices, symbol, amount, this.chainName);
    }
  }, {
    key: "convertDollarValueToDenomUnits",
    value: function convertDollarValueToDenomUnits(prices, symbol, value) {
      return (0, _utils.convertDollarValueToDenomUnits)(this._assets, prices, symbol, value, this.chainName);
    }
  }, {
    key: "convertBaseUnitsToDisplayUnits",
    value: function convertBaseUnitsToDisplayUnits(symbol, amount) {
      return (0, _utils.convertBaseUnitsToDisplayUnits)(this._assets, symbol, amount, this.chainName);
    }
  }]);
  return ChainRegistryChainUtil;
}();
exports.ChainRegistryChainUtil = ChainRegistryChainUtil;